import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import HectorLogo from '../assets/icons/HectorLogo';
import userDetails from '../utils/LoginCredentials';

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [credientialErrorMessage, setCredientialErrorMessage] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [userErrorMessage, setUserErrorMessage] = useState("");

  const handleLogin = () => {
    setUserErrorMessage("");
    setPasswordErrorMessage("");
    let isCredentialValid = false;
    console.log(`Username -> ${username} \n Password -> ${password}`);
    if (username !== "" && password !== "") {
      const user = userDetails.find((user) => user.username === username);
      if (username === user?.username && password === user.password) {
        isCredentialValid = true;
        localStorage.setItem("username", username);
      }

      if (isCredentialValid) {
        navigate("/", { replace: true });
        setCredientialErrorMessage("");
      } else {
        setCredientialErrorMessage("Invalid Username Or Password");
      }
    } else {
      if (username === "") setUserErrorMessage("Username is required");
      if (password === "") setPasswordErrorMessage("Password is required");
    }
  };
  return (
    <div className="flex flex-col justify-center items-center h-screen p-12 gap-5 bg-zinc-950">
      <HectorLogo className="h-24" />
      <form className="flex flex-col gap-2 items-center shadow">
        <div>
          <h1 className="text-[22px] font-medium mb-2 tracking-wider text-center">
            Log in to your account
          </h1>
          <p className="text-zinc-300 text-xs text-center">
            Welcome back! Please enter your details.
          </p>
        </div>
        <div className="h-5 w-full text-center text-sm text-red-400">
          {credientialErrorMessage ? <p>{credientialErrorMessage}</p> : ""}
        </div>
        <div className="flex flex-col justify-end gap-4 mt-auto pb-8">
          <div>
            <h3 className="text-sm mb-2">Email</h3>
            <div className="">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className={`flex items-center justify-center border border-zinc-800 rounded-md py-1.5 px-3 w-80 bg-zinc-900 bg-transparent pl-2 outline-none  text-zinc-300 font-light text-sm focus:ring-2 focus:ring-indigo-500 ${
                  userErrorMessage ? "border-red-400" : ""
                }`}
              />
              <p className="text-sm text-red-400 gap-1 pt-2">
                {userErrorMessage}
              </p>
            </div>
          </div>
          <div>
            <h3 className="text-sm mb-2">Password</h3>
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className={`flex items-center justify-center border border-zinc-800 rounded-md py-1.5 px-3 w-80 bg-zinc-900 bg-transparent pl-2 outline-none  text-zinc-300 font-light text-sm focus:ring-2 focus:ring-indigo-500 ${
                  passwordErrorMessage ? "border-red-400" : ""
                }`}
              />
              <p className="text-sm text-red-400 gap-1 pt-2">
                {passwordErrorMessage}
              </p>
            </div>
          </div>

          <button
            type="button"
            className="p-2 text-sm w-full rounded-md font-medium duration-300 bg-indigo-500 hover:bg-indigo-400 focus:outline-2 focus:outline-indigo-500"
            onClick={handleLogin}
          >
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
